import { render } from "./CobraPaymentsHistory.vue?vue&type=template&id=05bfa123&ts=true"
import script from "./CobraPaymentsHistory.vue?vue&type=script&lang=ts"
export * from "./CobraPaymentsHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__